import { render, staticRenderFns } from "./SdgGriRelevantExplanation.vue?vue&type=template&id=2b9e530b"
import script from "./SdgGriRelevantExplanation.vue?vue&type=script&lang=ts"
export * from "./SdgGriRelevantExplanation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSubSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSectionTitle.vue').default,IxSubSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSectionText.vue').default,IxMetricsSuggestionsBox: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/MetricsSuggestionsBox.vue').default,IxLeversBox: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/LeversBox.vue').default,IxSubSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SubSection.vue').default})
